import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function EcommerceCase() {
  return <CaseStudyPage slug="ecommerce-platform" />;
}